module.exports = __webpack_public_path__ + "img/partner3.2ef74cdd.png";